export default "__VITE_ASSET__CAGOrx9w__"